import { render, staticRenderFns } from "./CaseSession.vue?vue&type=template&id=4136b43f&scoped=true&lang=pug&"
import script from "./CaseSession.vue?vue&type=script&lang=js&"
export * from "./CaseSession.vue?vue&type=script&lang=js&"
import style0 from "./CaseSession.vue?vue&type=style&index=0&id=4136b43f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136b43f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
